export default __webpack_public_path__ + "static/media/blogPropsFacebookLogo.c7a25d43.PNG";